import { useEffect, useState } from 'react'

interface TimeLeft {
  hours: string
  minutes: string
  seconds: string
  total: number
}

const pad = (n: number) => n.toString().padStart(2, '0')

/**
 * Counts down from a given number of seconds. When it hits zero it resets
 * back to the start so the urgency bar always shows time remaining.
 */
export function useCountdown(initialSeconds = 45 * 60 + 12): TimeLeft {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds)

  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft((prev) => (prev <= 1 ? initialSeconds : prev - 1))
    }, 1000)
    return () => clearInterval(id)
  }, [initialSeconds])

  const hours = Math.floor(secondsLeft / 3600)
  const minutes = Math.floor((secondsLeft % 3600) / 60)
  const seconds = secondsLeft % 60

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    total: secondsLeft,
  }
}
